import { createFileRoute, redirect } from "@tanstack/react-router";
import { UnderMaintenancePage } from "@/features/maintenance/under-maintenance-page";
import { kIsUnderMaintenance } from "@/constants";
import { seo, SEO_SITE_URL } from "@/lib/utils/seo";

export const Route = createFileRoute("/under-maintenance")({
  component: RouteComponent,
  head: () => ({
    meta: [
      ...seo({
        title: "网站维护中 - CN Apex Club",
        description: "CN Apex Club 正在进行系统维护，预计很快恢复服务。感谢您的耐心等待！",
        url: `${SEO_SITE_URL}/under-maintenance`,
      }),
    ],
  }),
  beforeLoad() {
    if (!kIsUnderMaintenance) {
      throw redirect({
        to: "/",
        statusCode: 302,
        replace: true,
        headers: {
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        },
      });
    }
  },
});

function RouteComponent() {
  const navigate = Route.useNavigate();
  return <UnderMaintenancePage onContinue={() => navigate({ to: "/", replace: true })} />;
}
